import type { ReactNode } from "react";
import { PageTitle } from "./PageTitle";
import { ViewToggle } from "./ViewToggle";
import { SearchInput } from "./SearchInput";
import { PrimaryActions } from "./PrimaryActions";
import type { PageHeaderProps } from "./types";

interface ExtendedPageHeaderProps extends PageHeaderProps {
  filterSlot?: ReactNode;
}

export function PageHeader({
  title,
  viewOptions,
  onViewChange,
  filterSlot,
  searchValue,
  onSearchChange,
  searchPlaceholder,
  sortOptions,
  activeSort,
  onSortChange,
  actionSlot,
  selectedCount,
  onBulkDownload,
  onBulkDelete,
  onBulkArchive,
  onBulkUnarchive,
  onBulkExport,
}: ExtendedPageHeaderProps) {
  return (
    <div className="shrink-0 space-y-3 pb-4">
      {/* Row 1: Title + View Toggle + Automate / Share */}
      <div className="flex items-center gap-3">
        <PageTitle title={title} />
        {viewOptions && viewOptions.length > 0 && (
          <ViewToggle options={viewOptions} onViewChange={onViewChange} />
        )}
        <div className="flex-1" />
        <PrimaryActions
          selectedCount={selectedCount}
          onBulkDownload={onBulkDownload}
          onBulkDelete={onBulkDelete}
          onBulkArchive={onBulkArchive}
          onBulkUnarchive={onBulkUnarchive}
          onBulkExport={onBulkExport}
        />
        {actionSlot}
      </div>

      {/* Row 2: Search bar with inline actions */}
      <SearchInput
        filterSlot={filterSlot}
        searchValue={searchValue}
        onSearchChange={onSearchChange}
        placeholder={searchPlaceholder}
        sortOptions={sortOptions}
        activeSort={activeSort}
        onSortChange={onSortChange}
      />
    </div>
  );
}
